import { TileVariant } from '@/components/diagrams/components/Tile/types';
import { TileNodeProps } from '@/components/diagrams/FlowChart/nodes/TileNode/TileNode';
import { EntityKind, TestamentaryEntityKind } from '@/types/schema';

import {
  EntityDiagram_NodeFragment,
  GraphNodeCategorizationType,
} from '../types';

export const DEFAULT_SECTION_GROUP_HEIGHT = 1;

const ValidTypenames = [
  'TestamentaryEntity',
  'Entity',
  'ClientProfile',
  'ClientOrganization',
] as const;

export const ValidTypeNamesSet = new Set(ValidTypenames);

export type ValidTypeName = (typeof ValidTypenames)[number];
export type EntityNodeKind = EntityKind | TestamentaryEntityKind;
export type EntityNode = Extract<
  EntityDiagram_NodeFragment['node'],
  { __typename?: ValidTypeName }
>;

export const kindToCategorizationType: Record<
  EntityNodeKind,
  GraphNodeCategorizationType | null
> = {
  CCORP_BUSINESS_ENTITY: GraphNodeCategorizationType.PersonalAccount,
  GP_BUSINESS_ENTITY: GraphNodeCategorizationType.PersonalAccount,
  LLC_BUSINESS_ENTITY: GraphNodeCategorizationType.PersonalAccount,
  LP_BUSINESS_ENTITY: GraphNodeCategorizationType.PersonalAccount,
  SOLE_PROPRIETORSHIP_BUSINESS_ENTITY:
    GraphNodeCategorizationType.PersonalAccount,
  SCORP_BUSINESS_ENTITY: GraphNodeCategorizationType.PersonalAccount,

  // Entities
  CLT_TRUST: GraphNodeCategorizationType.CharitableEntity,
  CRT_TRUST: GraphNodeCategorizationType.CharitableEntity,
  CUSTODIAL_PERSONAL_ACCOUNT: GraphNodeCategorizationType.PersonalAccount,
  DONOR_ADVISED_FUND: GraphNodeCategorizationType.CharitableEntity,
  GRAT_TRUST: GraphNodeCategorizationType.FamilyGiving,
  ILIT_TRUST: GraphNodeCategorizationType.FamilyGiving,
  INDIVIDUAL_PERSONAL_ACCOUNT: GraphNodeCategorizationType.PersonalAccount,
  IRREVOCABLE_TRUST: GraphNodeCategorizationType.FamilyGiving,
  JOINT_PERSONAL_ACCOUNT: GraphNodeCategorizationType.PersonalAccount,
  INSURANCE_PERSONAL_ACCOUNT: GraphNodeCategorizationType.InsuranceAccount,
  PRIVATE_FOUNDATION: GraphNodeCategorizationType.CharitableEntity,
  QPRT_TRUST: GraphNodeCategorizationType.FamilyGiving,
  QUALIFIED_TUITION_PERSONAL_ACCOUNT:
    GraphNodeCategorizationType.PersonalAccount,
  RETIREMENT_PERSONAL_ACCOUNT: GraphNodeCategorizationType.PersonalAccount,
  REVOCABLE_TRUST: GraphNodeCategorizationType.FamilyGiving,
  SLAT_TRUST: GraphNodeCategorizationType.FamilyGiving,

  // Testamentary Entities
  CHARITABLE_ENTITY: GraphNodeCategorizationType.CharitableEntity,
  CHARITABLE_TRUST: GraphNodeCategorizationType.CharitableEntity,
  GRANTOR_ESTATE: GraphNodeCategorizationType.FamilyGiving,
  INHERITED_RETIREMENT_ACCOUNT: GraphNodeCategorizationType.PersonalAccount,
  TESTAMENTARY_TRUST: GraphNodeCategorizationType.FamilyGiving,
};
export const categorizationTypeToVariant: Record<
  GraphNodeCategorizationType,
  NonNullable<TileNodeProps['data']['variant']>
> = {
  [GraphNodeCategorizationType.CharitableEntity]: TileVariant.Tertiary,
  [GraphNodeCategorizationType.FamilyGiving]: TileVariant.Secondary,
  [GraphNodeCategorizationType.PersonalAccount]: TileVariant.Secondary,
  [GraphNodeCategorizationType.InsuranceAccount]: TileVariant.Secondary,
  [GraphNodeCategorizationType.Individual]: TileVariant.Secondary,
  [GraphNodeCategorizationType.GroupNode]: TileVariant.Default,
  [GraphNodeCategorizationType.SectionLabel]: TileVariant.Default, // not actually used
};

export const DEATH_PAYOUT_ENTITY_KINDS = [
  EntityKind.IlitTrust,
  EntityKind.InsurancePersonalAccount,
];
